// Custom validators for Vuelidate
// These validators extend the built-in Vuelidate validators

/**
 * Decimal validator - accepts any numeric value including decimals and negatives
 * @param {*} value - The value to validate
 * @returns {boolean} - True if valid decimal number, false otherwise
 */
export const decimal = (value) => {
  // Allow empty values
  if (!value && value !== 0) return true;

  // Convert to number and check if it's a valid finite number
  const num = Number(value);
  return !isNaN(num) && isFinite(num);
};

/**
 * Decimal validator with 2 decimal places limit
 * @param {*} value - The value to validate
 * @returns {boolean} - True if valid decimal with max 2 decimal places
 */
export const decimalTwoPlaces = (value) => {
  // Allow empty values
  if (!value && value !== 0) return true;

  // Check if matches decimal pattern with max 2 decimal places
  const regex = /^-?\d+(\.\d{0,2})?$/;
  return regex.test(String(value));
};
